import React, { createContext, useContext, useMemo } from 'react';

import { useContactActions } from './contacts-actions';

type ContactsContextType = {
  contactActions: ReturnType<typeof useContactActions>;
}

export const ContactsContext = createContext<ContactsContextType>(undefined as any);

export const useContactsContext = () => {
  return useContext(ContactsContext);
}

export const ContactsContextProvider = ({ children }: any) => {
  const contactActions = useContactActions();

  const context = useMemo(() => {
    return {
      contactActions,
    }
  }, [contactActions])

  return <ContactsContext.Provider value={context}>{children}</ContactsContext.Provider>
}
